import React from "react";
import "./VideoPlayer.css";

const videos = [
  { src: "https://www.youtube.com/embed/W-hgrLODCMw", title: "6 YEARS CURRICULUM OF MEDICINE & SURGERY IN ITALY | IMAT 2025 | STUDY IN ITALY" },
  { src: "https://www.youtube.com/embed/geejWrV0UMo", title: "IMAT 2025: How to Prepare & What Books to Use for Success | Study Medicine and Surgery in Italy" },
  { src: "https://www.youtube.com/embed/CT90tIUtOQI", title: "IMAT 2025 UPDATE | Syllabus, Test Centres, Costs, and My Personal Experience" },
];

const VideoGrid = () => {
  return (
    <div className="video-container">
      {videos.map((video, index) => (
        <div key={index} className="video-wrapper">
          <div className="video-card">
            <iframe
              src={video.src}
              title={`YouTube video ${index}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="video"
            ></iframe>
          </div>
          <h3 className="video-title">{video.title}</h3> {/* Title outside the video container */}
        </div>
      ))}
    </div>
  );
};

export default VideoGrid;







// import React, { useState, useEffect, useRef } from 'react';
// import BottomNavbar from "../components/Route/BottomNavbar/BottomNavbar";
// import { AiOutlineShoppingCart, AiOutlineShopping, AiOutlineHeart, AiOutlineComment } from 'react-icons/ai';

// const videos = [
//   '/videos/wewe1.mp4',
//   '/videos/wewe2.mp4',
//   '/videos/wewe3.mp4',
//   '/videos/wewe4.mp4',
// ];

// const SmallVideo = () => {
//   const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
//   const [showFullDescription, setShowFullDescription] = useState(false); // State for toggling description
//   const videoContainerRef = useRef(null);

//   const handleVideoEnd = () => {
//     setCurrentVideoIndex((prevIndex) =>
//       prevIndex + 1 < videos.length ? prevIndex + 1 : 0 // Loop back to the first video
//     );
//   };


//   const handleScroll = (event) => {
//     event.preventDefault(); // Prevent default scroll behavior

//     if (event.deltaY > 0) {
//       setCurrentVideoIndex((prevIndex) =>
//         prevIndex + 1 < videos.length ? prevIndex + 1 : 0 // Loop to first video if we reach end
//       );
//     } else {
//       setCurrentVideoIndex((prevIndex) =>
//         prevIndex - 1 >= 0 ? prevIndex - 1 : videos.length - 1 // Loop to last video if we go before first
//       );
//     }
//   };

//   const handleToggleDescription = () => {
//     setShowFullDescription((prev) => !prev); // Toggle the state for full description
//   };

//   useEffect(() => {
//     const videoContainer = videoContainerRef.current;
//     if (videoContainer) {
//       videoContainer.addEventListener('wheel', handleScroll, { passive: false });
//       videoContainer.addEventListener('touchmove', handleScroll, { passive: false });
//     }

//     return () => {
//       if (videoContainer) {
//         videoContainer.removeEventListener('wheel', handleScroll);
//         videoContainer.removeEventListener('touchmove', handleScroll);
//       }
//     };
//   }, []);

//   return (
//     <>
//       <div
//         ref={videoContainerRef}
//         style={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           height: 'calc(130vh - 220px)',
//           backgroundColor: '#000',
//           color: '#fff',
//           overflow: 'hidden',
//           position: 'relative',
//         }}
//       >
//         <div style={{
//           position: 'relative',
//           width: '100%',
//           paddingBottom: '175%',
//           backgroundColor: 'black',
//           overflow: 'hidden',
//         }}>
//           <video
//             key={currentVideoIndex}
//             controls
//             autoPlay
//             style={{
//               position: 'absolute',
//               top: 0,
//               left: '50%',
//               transform: 'translateX(-50%)',
//               width: '100%',
//               height: '100vh',
//             }}
//             onEnded={handleVideoEnd}
//           >
//             <source src={videos[currentVideoIndex]} type="video/mp4" />
//             Your browser does not support the video tag.
//           </video>
//         </div>

//         {/* Profile Picture and Name */}
//         <div
//           style={{
//             position: 'absolute',
//             left: '10px',
//             top: '88%',
//             transform: 'translateY(-50%)',
//             display: 'flex',
//             alignItems: 'center',
//             color: '#fff',
//           }}
//         >
//           <img
//             src="https://randomuser.me/api/portraits/men/75.jpg"
//             alt="Profile"
//             style={{
//               width: '40px',
//               height: '40px',
//               borderRadius: '50%',
//               border: '2px solid #fff',
//               marginRight: '10px',
//             }}
//           />
//           <div>
//             <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Honesty Mode Wear</span>
//             <br />
//             <span
//               onClick={handleToggleDescription}
//               style={{
//                 fontSize: '14px',
//                 // fontWeight: 'bold',
//                 cursor: 'pointer',
//                 color: '#fff',
//               }}
//             >
//               {showFullDescription
//                 ? "Best wears for all categories | Available sizes: 6, 8 & 10. | Available colors:  Red, Blue, Yellow & Green" // Show full description when clicked
//                 : "Best wears for all categories.".slice(0, 25) + '...'}
//             </span>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default SmallVideo;